import get from 'lodash.get';

const getContactSupportUrl = (rootState) =>
  get(rootState, 'user.partnerData.properties.contactSupportUrl', null);

export default getContactSupportUrl;
